import { ReactNode } from "react";

import { Toaster } from "@ps-design-system/components/Toast";

import { LoadingPage } from "@/components/LoadingPage";

import { AppHeader } from "./components/AppHeader/AppHeader";
import useSetDataDogUserId from "./lib/datadog/useSetDataDogUserId";
import { StatsigReactProvider } from "./lib/statsig/StatsigReactProvider";
import { useAuthStore } from "./store/auth.store";

type AppProps = {
  children: ReactNode;
};

const App = ({ children }: AppProps) => {
  const { authInitialized } = useAuthStore((state) => ({
    authInitialized: state.authInitialized,
  }));

  // attached the user's SSOid in Datadog
  useSetDataDogUserId();

  if (!authInitialized) {
    return <LoadingPage />;
  }

  return (
    <>
      <StatsigReactProvider>
        <AppHeader />
        {children}
        <Toaster
          viewportProps={{
            className: "!tw-top-auto !tw-bottom-0 !tw-flex-col",
            style: { pointerEvents: "none" },
          }}
        />
      </StatsigReactProvider>
    </>
  );
};

export default App;
